/* Imports */
import React from "react"
import { Link } from "react-router-dom"
import { Font } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const FooterPage = () => {
    const items = [
        {
            title: "Without separator",
            content: (
                <Font.P>
                    <Link to="/components/footer/demo" target="_blank" rel="noreferrer noopener">
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Footer logoImg="/images/logo-fajny-css.svg">\n    <Link to="#">Link</Link>\n    <Link to="#">Link</Link>\n    <Link to="#">Link</Link>\n    <Link to="#">Link</Link>\n</Footer>',
        },
        {
            title: "With separator",
            content: (
                <Font.P>
                    <Link to="/components/footer/demo-separator" target="_blank" rel="noreferrer noopener">
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Footer logoImg="/images/logo-fajny-css.svg" separator>\n    <Link to="#">Link</Link>\n    <Link to="#">Link</Link>\n    <Link to="#">Link</Link>\n    <Link to="#">Link</Link>\n</Footer>',
        },
    ]

    const propsItems = [
        {
            name: "logoImg",
            type: "String",
            example: "/images/logo-fajny-css.svg",
        },
        {
            name: "logoAlt",
            type: "String",
            example: "Logo Fajny CSS",
            default: "Logo",
        },
        {
            name: "logoText",
            type: "String",
            example: "Fajny CSS",
        },
        {
            name: "separator",
            type: "Boolean",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default FooterPage
